import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import { OutlinedInput, Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../theme/ThemeContext";
import { useContext, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CustomDateFilter(props) {
  const { darkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = React.useState([t("Today")]);

  const names = [t("Today"), t("Last 7 Days"), t("Last 30 Days"), t("All")];

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  const dateFilter = (days) => {
    if (days === "All") {
      var sdate = "";
      var edate = "";
      props.datePickerFilter(sdate, edate);
    } else {
      var today = new Date();
      var todayDate = new Date();
      var edate =
        today.getFullYear() +
        formatDayAndMonth(today.getMonth() + 1) +
        formatDayAndMonth(today.getDate()) +
        "T23:59:59";
      var last = new Date(todayDate.getTime() - days * 24 * 60 * 60 * 1000);
      var sdate =
        last.getFullYear() +
        formatDayAndMonth(last.getMonth() + 1) +
        formatDayAndMonth(last.getDate()) +
        "T00:00";
      props.datePickerFilter(sdate, edate);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedValue(typeof value === "string" ? value.split(",") : value);

    if (value === "Today" || value === "Hoy") {
      dateFilter(0);
    } else if (value === "Last 7 Days" || value === "Últimos 7 días") {
      dateFilter(7);
    } else if (value === "Last 30 Days" || value === "Últimos 30 Días") {
      dateFilter(30);
    } else if (value === "All" || value === "Todos") {
      dateFilter("All");
    }
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const menuProps = {
    PaperProps: {
      sx: {
        backgroundColor: darkMode ? "#1c354b" : "",
      },
    },
  };

  return (
    <div>
      <FormControl
        sx={{
          width: "180px",
          height: "48px",
          borderRadius: "8px",
          "& .MuiOutlinedInput-root": {
            height: "48px",
            bgcolor: darkMode ? "#0E2A41" : "#fff",
            color: darkMode ? "#fff" : "#000",
            borderRadius: "8px",
            borderRadius: 1,
            "& fieldset": {
              borderColor: darkMode ? "#576A7A" : "#ccc",
            },
            "&:hover fieldset": {
              borderColor: darkMode
                ? " rgba(130, 130, 130, 1)"
                : "rgba(0, 0, 0, 0.4)",
            },
            "&.Mui-focused fieldset": {
              borderColor: "rgb(25, 118, 210)",
            },
            "& .MuiSvgIcon-root-MuiSelect-icon": {
              color: "rgb(25, 118, 210) !important",
            },
          },
        }}
      >
        <Select
          IconComponent={ExpandMoreIcon}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            color: darkMode ? "#fff" : "#000",
            height: "44px",
            display: "flex",
            alignItems: "center",
            borderRadius: "8px",
          }}
          inputProps={{
            classes: {
              notchedOutline: "notched-outline",
            },
          }}
          sx={{
            height: "42px",
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              padding: "0px 10px !important",
              minHeight: "42px !important",
              textAlign: "left",
              justifyContent: "flex-start",
            },
            "& .MuiSelect-icon": {
              color: "#949596 !important",
            },
          }}
          displayEmpty
          defaultValue={t("Today")}
          value={selectedValue}
          onChange={handleChange}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <span>{t("Today")}</span>;
            }
            return selected.join(", ");
          }}
          MenuProps={menuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{
                color: darkMode ? "#fff" : "#000",
                borderRadius: "8px",
              }}
            >
              <Radio checked={selectedValue.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
